var _path, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgGeneralContracting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.6665V9.99984C12.4998 10.9165 11.7498 11.6665 10.8332 11.6665H1.6665V4.99984C1.6665 3.15817 3.15817 1.6665 4.99984 1.6665H12.4998Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 11.6665V14.1665C18.3332 15.5498 17.2165 16.6665 15.8332 16.6665H14.9998C14.9998 15.7498 14.2498 14.9998 13.3332 14.9998C12.4165 14.9998 11.6665 15.7498 11.6665 16.6665H8.33317C8.33317 15.7498 7.58317 14.9998 6.6665 14.9998C5.74984 14.9998 4.99984 15.7498 4.99984 16.6665H4.1665C2.78317 16.6665 1.6665 15.5498 1.6665 14.1665V11.6665H10.8332C11.7498 11.6665 12.4998 10.9165 12.4998 9.99984V4.1665H14.0332C14.6332 4.1665 15.1832 4.49151 15.4832 5.00818L16.9082 7.49984H15.8332C15.3748 7.49984 14.9998 7.87484 14.9998 8.33317V10.8332C14.9998 11.2915 15.3748 11.6665 15.8332 11.6665H18.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 18.3333C14.2536 18.3333 14.9998 17.5871 14.9998 16.6667C14.9998 15.7462 14.2536 15 13.3332 15C12.4127 15 11.6665 15.7462 11.6665 16.6667C11.6665 17.5871 12.4127 18.3333 13.3332 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10V11.6667H15.8333C15.375 11.6667 15 11.2917 15 10.8333V8.33333C15 7.875 15.375 7.5 15.8333 7.5H16.9083L18.3333 10Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralContracting);
export default __webpack_public_path__ + "static/media/general_contracting.6a05c809.svg";
export { ForwardRef as ReactComponent };